import CommunitiesLayout from "./Layout";
import LandingsApp from "../../communities/pages/landings/App";

function Landing() {
  return <LandingsApp />;
}
Landing.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>;
export default Landing;
